import * as React from 'react';

import classnames from 'classnames';

import {ActionMenu} from '../action-menu/action-menu';
// @ts-expect-error - imported from .js/.jsx file
import {EditableTimestamp} from '../editable-timestamp/editable-timestamp';
import {FlashBanner} from '../flash-banner/flash-banner';

import styles from './list-row-activity.module.css';

type Props = {
    options: any[];
    style?: any;
    onClick?: (e: React.SyntheticEvent) => void;
    formattedTimestamp?: string;
    timestamp?: number;
    onTimeChange?: () => any;
    secondLine?: React.ReactElement<any>;
    isOverdue?: boolean;
    isCompleted?: boolean;
    isSelected?: boolean;
    hasBorders?: boolean;
    hideActionMenu?: boolean;
    errorMessage?: string;
    onClearError?: () => any;
    children?: React.ReactNode;
    anchorElementId?: string;
};

export class ListRowActivity extends React.Component<Props> {
    static defaultProps = {
        options: [],
    };

    render() {
        const styleNames = classnames(styles.container, {
            [styles['container-selected']]: this.props.isSelected,
            [styles['container-completed']]: this.props.isCompleted,
            [styles['container-overdue']]: this.props.isOverdue,
            [styles['container-bordered']]: this.props.hasBorders,
            [styles['container-clickable']]: this.props.onClick,
        });

        return (
            <div style={this.props.style} onClick={this.handleRowClick} className={styleNames}>
                <div className={styles['border-container']}>
                    <div className={styles['right-column']}>
                        <div className={styles['right-container']}>
                            <div className={styles['first-column']}>
                                {this.props.timestamp && this.props.formattedTimestamp ? (
                                    <div className={styles['timestamp-container']}>
                                        <EditableTimestamp
                                            formattedValue={this.props.formattedTimestamp}
                                            value={this.props.timestamp}
                                            onTimeChange={this.props.onTimeChange}
                                        />
                                    </div>
                                ) : undefined}
                                {this.props.secondLine ? (
                                    <div className={styles['secondary-text']}>
                                        {this.props.secondLine}
                                    </div>
                                ) : undefined}
                            </div>
                        </div>
                    </div>
                    <div className={styles['left-column']}>
                        <div className={styles['item-container']}>{this.props.children}</div>
                    </div>
                    {this.props.options.length && !this.props.hideActionMenu ? (
                        <div className={styles['action-menu-container']}>
                            <ActionMenu
                                options={this.props.options}
                                callMountId={this.props.anchorElementId}
                            />
                        </div>
                    ) : (
                        this.renderEmptyActionMenu()
                    )}
                </div>
                {this.props.errorMessage ? (
                    <div className={styles.error}>
                        <FlashBanner onHidden={this.props.onClearError} type='error'>
                            <div>{this.props.errorMessage}</div>
                        </FlashBanner>
                    </div>
                ) : undefined}
            </div>
        );
    }

    handleRowClick = (e: React.SyntheticEvent) => {
        if (typeof this.props.onClick === 'function') {
            this.props.onClick(e);
        }
    };

    renderEmptyActionMenu() {
        return this.props.hideActionMenu ? undefined : (
            <div className={styles['action-menu-container']} />
        );
    }
}
